/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FlagPermissionLastBalance = {
  permission_v2_enable: new FcsFlag.Flag(false)
}

export function initFlagPermissionLastBalance() {
  FcsFlag.register("lastBalance", FlagPermissionLastBalance);
}

